import { navigateToUrl } from '@/modules/routing/helpers';

export function navigateToSignupWithMakeOfferRedirect(
  pathname: string,
  searchParams: URLSearchParams
) {
  const currentUrl = `${pathname}${searchParams.size > 0 ? `?${searchParams}&` : '?'}makeOfferModal=true`;
  navigateToUrl(`/signup?redirect=${encodeURIComponent(currentUrl)}`);
}
